export const truBrokerCriteriaIcons = {
  'active-listings-gt-4': {
    icon: 'FaList',
  },
  'avg-listing-health-gt-50': {
    icon: 'SvgHealth',
  },
  'upgrade-to-hot': {
    icon: 'IconSuperHot',
    iconColor: '#f73131',
  },
  'upgrade-to-signature': {
    icon: 'BsFillLightningChargeFill',
    iconColor: '#af6fff',
  },
  'post-a-listing': {
    icon: 'FaList',
  },
  'trubroker-3-months': {
    icon: 'TruBrokerStarIcon',
  },
  'trubroker-6-months': {
    icon: 'TruBrokerStarIcon',
  },
  'activate-trucheck-rented': {
    icon: 'TruCheckIcon',
  },
  'activate-trucheck-sale': {
    icon: 'TruCheckIcon',
  },
};
